import React from "react";
import {Col, Container, Image, Row, Spinner} from "react-bootstrap";

interface Props {
}

export const Loading = ({}: Props) => {

    return <>
        <Container
            className={"contentContainer"}
            style={{
                height: "calc(100vh - 76px)",
                marginTop: "0px",
            }}
            fluid={true}
        >
            <div
                style={{
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                }}
            >
                <div
                    style={{
                        minWidth: "50%",
                        width: "auto",
                        height: "auto",
                        padding: "10px",
                        backgroundColor: "white",
                        borderRadius: "10px",
                    }}
                >
                    <Row>
                        <Image
                            src={"./logo.svg"}
                            className="card_menu_img"
                            style={{ margin: "auto", height: "100px" }}
                        />
                    </Row>
                    <Col style={{display: 'flex', padding: '5em', justifyContent: 'center'}}>
                        <Spinner animation="border" />
                    </Col>
                </div>
            </div>
        </Container>
    </>
}